{
  "LOGIN": {
    "TITLE": "Accedi al Contact Center",
    "EMAIL": {
      "LABEL": "Email",
      "PLACEHOLDER": "example{'@'}companyname.com",
      "ERROR": "Inserisci un indirizzo email valido"
    },
    "PASSWORD": {
      "LABEL": "Password",
      "PLACEHOLDER": "Password"
    },
    "API": {
      "SUCCESS_MESSAGE": "Accesso riuscito",
      "ERROR_MESSAGE": "Impossibile connettersi al server Woot, riprova più tardi",
      "UNAUTH": "Nome utente / Password errati. Riprova",
      "ACCOUNT_DEACTIVATED": "Il tuo account è stato disattivato. Contatta il tuo amministratore.",
      "PASSWORD_LOGIN_DISABLED": "Il login con password è disabilitato per il tuo account. Accedi utilizzando OAuth (es. Google)."
    },
    "OAUTH": {
      "GOOGLE_LOGIN": "Login with Google",
      "BUSINESS_ACCOUNTS_ONLY": "Please use your company email address to login",
      "NO_ACCOUNT_FOUND": "We couldn't find an account for your email address."
    },
    "FORGOT_PASSWORD": "Password dimenticata?",
    "CREATE_NEW_ACCOUNT": "Crea un nuovo account",
    "SUBMIT": "Accedi"
  }
}
